import LocationDetails from "../entities/LocationDetails";
import { SettingsRepository } from "../repositories/SettingsRepository";

export class GetDetailsPlace {
	constructor(private repository: SettingsRepository) {}

	execute(params: GetDetailsPlaceParams): Promise<LocationDetails> {
		return this.repository.getDetailsPlace(params.place_id);
	}
}

export class GetDetailsPlaceParams {
	constructor(public place_id: string) {}
}
